import React from 'react';
import UserDashboard from '../../Users/UserDashboard/userDashboard';
import './activeAlterations.css';

function ActiveAlterations() {
    return (
        <div className="active-alterations-container">
            <UserDashboard />
        </div>
    );
}

export default ActiveAlterations;
